import type { SlabReading } from "./api";

// D, 7 October 2026: grade first, then card, set, number, year/region/era and certificate.
export function slabLabelDescription(label: SlabReading): string {
  // Older readers did not separate the printed era. Keep their full text rather than lose it.
  if (label.yearRegionEra === undefined && label.labelText?.trim()) return label.labelText.trim();
  return [
    [label.grader, label.grade, label.gradeDescription].filter(Boolean).join(" "),
    label.cardName,
    label.setName,
    label.cardNumber ? `#${label.cardNumber.replace(/^#+/, "")}` : null,
    label.yearRegionEra ?? [label.yearReleased, label.language].filter(Boolean).join(" "),
    label.rarity,
    label.certNo ? `Cert ${label.certNo}` : null,
  ].filter((part) => part != null && String(part).trim() !== "")
    .map((part) => `[${String(part).trim()}]`).join(" ");
}
